import { render } from "./GalleryCard.vue?vue&type=template&id=6c96a836"
import script from "./GalleryCard.vue?vue&type=script&lang=js"
export * from "./GalleryCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__